import React from 'react';

export default function MapFooter() {
  return (
    <div className="map-wrapper">
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2463.65993087496!2d-2.2452206842167723!3d51.86716527969583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48710664ca215d9b%3A0xec95d22d0a7ebbec!2sStudent+Digs+Gloucestershire!5e0!3m2!1sen!2suk!4v1555582264986!5m2!1sen!2suk"
        allowFullScreen
      />
    </div>
  );
}
